export default __webpack_public_path__ + "static/media/infra-7.9cfff73c.webp";